import http from '@/plugin/axios'
import { downloadFile } from '@/api/common/index'

export async function parse(this: any) {
  return this.data.fileList.map((item: any) => {
    return {
      name: item.fileName,
      fileId: item.fileId
    }
  })
}

export function onSuccess(this: any, res: any, file: any, fileList: any[]) {
  const { id: fileId, fileName } = res.data
  file.fileId = fileId
  file.fileName = fileName
  this.data.fileList = fileList.map(({ response }) => ({ fileId: response.data.id, fileName: response.data.fileName }))
}

export function beforeRemove(this: any, file: any) {
  this.data.fileList = this.data.fileList.filter((item: any) => item.fileId !== file.fileId)
}

export function submit(this: any, data: any) {
  const id = this.$route.params.id
  return http({
    url: '/srmData/sendSup',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: {
      id,
      sendRecordList: data.sendRecordList
    }
  })
}

export function clickFile(file: any) {
  downloadFile(process.env.VUE_APP_PURCHASE_API + '/srmFile/getFile', { fileId: file.fileId }, file.name)
}
